import type { Session } from "@supabase/supabase-js";
import type { Subscription } from "@coffitivity/shared";

export interface CurrentUserPlanResponse {
	subscription: Subscription | null;
}

export const fetchCurrentUserPlan = async (
	session: Session,
): Promise<CurrentUserPlanResponse> => {
	const response = await fetch(
		`${import.meta.env.VITE_USER_SERVER_URL}/user/plan`,
		{
			method: "GET",
			headers: {
				Authorization: `Bearer ${session.access_token}`,
				"Content-type": "application/json; charset=UTF-8",
			},
		},
	);
	const json = (await response.json()) as CurrentUserPlanResponse & {
		message?: string;
	};

	if (!response.ok) {
		throw new Error(json.message ?? "Failed to fetch user Plan.");
	}

	return {
		subscription: json.subscription ?? null,
	};
};
